import { connect } from 'react-redux'

import ProductCard from './ProductCard'

const mapStateToProps = ({ productsv2: products }, { sku }) => products[sku]

export default connect(mapStateToProps)(ProductCard)



// WEBPACK FOOTER //
// ./src/features/Availability/ProductCard/ProductCardContainer.js